
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  if(summary.closest('details') != null){
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  }
  
  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.input.addEventListener('input', (event) => {
      var btnCartCheckout = document.querySelectorAll('.cart__checkout-button');
      if(btnCartCheckout.length > 0){
        btnCartCheckout.forEach(submitButton => {
          submitButton.style.display = "none";
          submitButton.closest('.cart__btn_group').querySelector('.static_checkout_button').style.display = "block";
        });
      }
    });

    this.input.addEventListener('change', (event) => {

      var qty = Number(this.input.value);
      
      if(this.input.closest('.product__info-wrapper') != null){
        var minQty = Number(this.input.getAttribute('min'));
        if(qty < minQty){
          this.input.value = minQty;
          if(this.input.closest('.product__info-wrapper').querySelector('.min-qty-error') != null){
            this.input.closest('.product__info-wrapper').querySelector('.min-qty-error').style.display = "block";
          }
        }else{
          if(this.input.closest('.product__info-wrapper').querySelector('.min-qty-error') != null){
            this.input.closest('.product__info-wrapper').querySelector('.min-qty-error').style.display = "none";
          }
        }
      }

      if(event.target.closest('.MainProduct__section') != null){
        if(!(event.target.closest('.MainProduct__section').classList.contains('product_d2c'))){
          var oldValue = this.input.getAttribute('value');
          var currQty = Number(this.input.value);
          var interVal = Number(this.input.getAttribute('data-plus-step'));
          var mod = Number(currQty % interVal);
          console.log('mod--',mod);
          if(mod == 0){
            this.input.value = currQty;
            this.input.setAttribute('value',currQty);
          }else{
            this.input.value = oldValue;
          }  
  
          var newSpan = document.createElement('span');
          var demoDiv = this.input.closest('quantity-input.quantity');
  
          newSpan.classList.add("qty-error-msg");
          newSpan.innerHTML = 'This product is only sold on interval of '+ interVal;
  
          if(demoDiv.querySelectorAll('.qty-error-msg').length > 0){
          }else{
            demoDiv.appendChild(newSpan);
          }
  
          if(mod == 0){
            demoDiv.querySelector('.qty-error-msg').style.display = "none";
          }else{
            demoDiv.querySelector('.qty-error-msg').style.display = "block";
          }
        }
      }

      qtyPriceUpdate();
    });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    var itemDrawerContains = false;
    var itemContains = false;
    var contains = false;


    var btnCartCheckout = document.querySelectorAll('.cart__checkout-button');
    if(btnCartCheckout.length > 0){
      btnCartCheckout.forEach(submitButton => {
        submitButton.style.display = "none";
        submitButton.closest('.cart__btn_group').querySelector('.static_checkout_button').style.display = "block";
      });
    }
    

    if(event.target.closest('.MainProduct__section') != null){
      var classes = event.target.closest('.MainProduct__section').getAttribute('class').split(' ');
       contains = classes.indexOf('product_d2c') > -1;
    }

    if(event.target.closest('.cart-item__quantity') != null){
      var itemCart = event.target.closest('.cart-item__quantity').getAttribute('class').split(' ');
       itemContains = itemCart.indexOf('cart-item-d2c') > -1;
    }

    if(event.target.closest('.cart-items__qty') != null){
      var itemCartDrawer = event.target.closest('.cart-items__qty').getAttribute('class').split(' ');
      itemDrawerContains = itemCartDrawer.indexOf('cart-item-d2c') > -1;
    }
    
    if(contains || itemContains || itemDrawerContains){
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    }else{
      var inputDownStep = Number(this.input.getAttribute('data-step'));
      var inputPlusStep = Number(this.input.getAttribute('data-plus-step'));
      event.target.name === 'plus' ? this.input.stepUp(inputPlusStep) : this.input.stepDown(inputDownStep);
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    var minQty = Number(this.input.getAttribute("min"));
    var inputVal = Number(this.input.value);

    if(inputVal <= minQty){
      if(this.querySelector(".min-qty-error") != null){
        this.querySelector(".min-qty-error").style.display = "block";
      }
    }else{
      if(this.querySelector(".min-qty-error") != null){
        this.querySelector(".min-qty-error").style.display = "none";
      }
    }

    qtyPriceUpdate();
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');
    document.body.classList.add('body-menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove('body-menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
   
    if(this.currentVariant){
      if(this.querySelectorAll('.selected_label').length > 0){
        var allLabel = this.querySelectorAll('.selected_label');
        for (var i = 0; i < allLabel.length; i++) {
          allLabel[i].textContent = this.currentVariant.options[i];
        }
      }
      if(this.currentVariant.sku != null){
        var currentSku = this.currentVariant.sku;
        if(this.closest('.product__info-container').querySelector('.product-sku') != null){
          if(currentSku.includes("#")){
            this.closest('.product__info-container').querySelector('.product-sku').innerHTML = currentSku;
          }else{
            this.closest('.product__info-container').querySelector('.product-sku').innerHTML = '# '+currentSku;
          }
        }
        if(this.closest('.product__info-container').querySelector('.specific_item_code') != null){
          this.closest('.product__info-container').querySelector('.specific_item_code p').textContent = currentSku;
        }
      }
      
      document.querySelector('[id^="price"]').setAttribute('data-variant-price',this.currentVariant.price);

      // console.log('price--',this.currentVariant.price);

      var variantId = this.currentVariant.id;
      var selectBox = document.querySelector('.select__select option[value="'+variantId+'"]');
      var minQtyVal = Number(selectBox.getAttribute('data-min-qty'));

      if(this.closest('.product__info-container').querySelector('.quantity__input') != null){

        const currentQty = Number(this.closest('.product__info-container').querySelector('.quantity__input').value);

        if(currentQty >= minQtyVal){
          this.closest('.product__info-container').querySelector('.quantity__input').value = currentQty;
        }else{
          this.closest('.product__info-container').querySelector('.quantity__input').value = minQtyVal;
        }
        this.closest('.product__info-container').querySelector('.quantity__input').setAttribute("min", minQtyVal);
      }

      if(this.closest('.product__info-container').querySelector('.min-qty-error') != null){
        this.closest('.product__info-container').querySelector('.min-qty-error').innerHTML = "You need to add minimum "+ minQtyVal +" quantity";
      }

      qtyPriceUpdate();
      handleChange();
    }
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    //mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    var viewer = document.querySelector('[id^="GalleryViewer"]');
    const activeMedia = viewer.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
    var currSlide = Number(activeMedia.parentElement.getAttribute('data-slide'));
    swiperGallery.slideTo(currSlide,500,false);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if(document.querySelectorAll('.th-do-table').length == 0){
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

/* custom js */

window.addEventListener("load", (event) => {
  setTimeout(function(){
    var body = document.getElementsByTagName("BODY")[0];
      var currcustomer = body.getAttribute("data-customer");
      var itemArr = [];
    
      if(currcustomer == 'B2B'){
        var elements = document.querySelectorAll(`[data-item-tag^="D2C"]`);
        elements.forEach(element => {
          var itemKey = element.getAttribute("data-key");
          itemArr.push(itemKey);
        });
      }

      if(currcustomer == 'D2C'){
        var elements = document.querySelectorAll(`[data-item-tag^="B2B"]`);
        elements.forEach(element => {
          var itemKey = element.getAttribute("data-key");
          itemArr.push(itemKey);
        });
      }

      var updateData = {}
      var defaultQty = Number(0);
      itemArr.forEach(arrVal => {
        updateData[arrVal] = defaultQty;
      });
    // console.log('loadcart--',Object.keys(updateData).length)
    if(Object.keys(updateData).length > 0){
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updateData
        })
      }).then(response => response.json())
        .then((newCart) => {
          console.log('Updated cart:', newCart);
          load_cart();
        })
        .catch(console.error)
      }
  }, 200);
});


function qtyPriceUpdate() {
  var inputTag = document.querySelector('.product-form__input .quantity__input');
  
  if(document.querySelectorAll('.th-do-table')[0] != undefined){

    var currentQty = Number(inputTag.value);
    var minQty = 0;
    var maxQty = 0;
    var hasInRange = false;
    var hasDefaultPrice = true;
    
    if (document.querySelectorAll('.th-do-table')[0].childNodes.length > 0) {  
      var tdElements = document.querySelectorAll('.th-do-table tbody tr');
      var tdElementsSize = tdElements.length - 1;
      
      tdElements.forEach((tdElement,i) => {
        var minQtyVal = Number(tdElement.getElementsByTagName('td')[0].getAttribute('data-discount_qty'));
        var maxQtyValue = tdElement.getElementsByTagName('td')[0].getAttribute('data-discount_max_qty');
        var tablePrice = tdElement.getElementsByTagName('td')[1].children[0].innerHTML;
        var finalPrice = tablePrice.replace(/[^\w\s]/g, "");
        
        if(i == 0){
          minQty = minQtyVal;
        }
        if(i == tdElementsSize){
          maxQty = minQtyVal;
        }

        if(maxQtyValue == '+'){
          if(currentQty >= minQtyVal){
            hasInRange = true;
            document.querySelector('.price-with-qty .price-item--regular').innerHTML = Shopify.formatMoney(finalPrice);
            inputTag.setAttribute('data-price',finalPrice);
          }
        }else{
          var maxQtyVal = Number(maxQtyValue);
          if(currentQty <= maxQtyVal && currentQty >= minQtyVal){
            hasInRange = true;
            document.querySelector('.price-with-qty .price-item--regular').innerHTML = Shopify.formatMoney(finalPrice);
            inputTag.setAttribute('data-price',finalPrice);
          }
        }
      });
      
      if(currentQty >= minQty && currentQty <= maxQty){
        hasDefaultPrice = false;
      }
      if(currentQty > maxQty){
        hasDefaultPrice = false;
      }
      
      if(hasDefaultPrice){
        var price = document.querySelector('[id^="price"]').getAttribute('data-original-price');
        document.querySelector('.price-with-qty .price-item--regular').innerHTML = Shopify.formatMoney(price);
        inputTag.setAttribute('data-price',price);
      }
    }
    if(!hasInRange){
      var variantPrice = document.querySelector('[id^="price"]').getAttribute('data-variant-price');
      document.querySelector('.price-with-qty .price-item--regular').innerHTML = Shopify.formatMoney(variantPrice);
      inputTag.setAttribute('data-price',variantPrice);
    }
  }

  if(inputTag != undefined){
    if(inputTag.getAttribute('data-price') != null){
      if(document.querySelector('.total_amt') != null){
        var curQty = inputTag.value;
        var currPrice = inputTag.getAttribute('data-price');
        var totalAmt = Number(curQty * currPrice);
        document.querySelector('.total_amt').innerHTML = Shopify.formatMoney(totalAmt);
      }
    }
  }
  
}


document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelector('[id^="GalleryViewer"]') != null ){
    if(document.querySelector('.template-product fieldset.product-form__input input:checked') != null){
      if(document.querySelector('fieldset.product-form__input input:checked').checked){
        var cuurentViewer = document.querySelector('[id^="GalleryViewer"]');
        const cuurentMedia = cuurentViewer.querySelector('.product__media-item.is-current-img');
        var cuurentSlide = Number(cuurentMedia.parentElement.getAttribute('data-slide'));
        swiperGallery.slideTo(cuurentSlide,500,false);
      }
    }
  }
});

function matchHeight(ul,grid,title,dg,mg){
  var gridWrap = document.getElementsByClassName(ul)[0];
  if(typeof gridWrap != 'undefined' || gridWrap != null){
    var els = gridWrap.getElementsByClassName(grid);
    var initialStart = 0;
    var defaultHeight = 0;
    var totalGridCount = els.length - 1;
    var grid__count = 0;
    for(var i = 0; i < els.length; i++){
      initialStart = initialStart + 1;
      if(els[i].getElementsByClassName(title)[0] != undefined ){
        var currentHeight = els[i].getElementsByClassName(title)[0].offsetHeight;
        if(currentHeight > defaultHeight){
          defaultHeight = currentHeight;
        }
        var gridCount = dg;
        var gridCountMinus = dg - 1;
        
        var screencWidth = document.documentElement.clientWidth;
        if(screencWidth < 769){
          var gridCount = mg;
          var gridCountMinus = mg - 1;
        }
        if(initialStart == gridCount || totalGridCount == i){
          var startIndex = grid__count;
          
          for(var j=startIndex; j<=i; j++){
            if(els[j]){
              els[j].getElementsByClassName(title)[0].style.minHeight = defaultHeight+'px';
                grid__count = grid__count + 1;
            }
          }
          initialStart = 0;
          defaultHeight = 0;
        }
      }
    }
  }
}

(function () {
  matchHeight('product-item-list','product-item','card__heading',3,2);
  matchHeight('product-item-list','product-item','variant_selector',3,2);
  matchHeight('product-item-list','product-item','card-information',3,2);
  matchHeight('Main-custmiztion','product-custmization-card','h2',2,1);
  matchHeight('Main-custmiztion','product-custmization-card','custmization-subtitle',2,1);
  matchHeight('featured-card-grid','featured-card-inner','h2',2,1);
  matchHeight('featured-card-grid','featured-card-inner','custmization-subtitle',2,1);
  matchHeight('megamenu__featured','card-wrapper','card__heading',2,1);
  matchHeight('cart-recom-pro','card-wrapper','variant_selector',4,4);
  matchHeight('template-press','multicolumn-list__item','multicolumn-card_title',4,2);
})();


if (window.innerWidth < 990) {
  var allTab = document.querySelectorAll(".main-tabs ul.nav-item li a");
  if(allTab.length > 0){
    allTab.forEach(clickA => {
      clickA.addEventListener("click", function(){ 
        var slected_text = clickA.closest('.main-tabs').querySelector('.dropdown');
        var drop_text = this.textContent;
        slected_text.textContent = drop_text;
        slected_text.classList.toggle("active");
        document.getElementById('nav-target').style.height = "0px";
      });
    });
  }

  if(document.querySelector(".main-tabs .dropdown") != null){
    var dropdownBtn = document.querySelector(".main-tabs .dropdown");
    var mdiv = document.getElementById('nav-target').offsetHeight;
    setTimeout(function(){
       document.getElementById("nav-target").setAttribute("style", "opacity: 1; visibility: visible;height:0;");
    }, 1000);
      function slideToggle(ele) {
        if(dropdownBtn.classList.contains('active')){
          document.getElementById('nav-target').style.height = "0px";
          ele.classList.remove('active');
        }else{
          document.getElementById('nav-target').style.height = mdiv + "px";
          ele.classList.add('active');
        }
    }
  }
}

if(document.querySelector('.product-slider') != null){
  var productSlider = new Swiper(".product-slider", {
    slidesPerView: "auto",
    noSwiping: true,
    onlyExternal: true,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      990: {
        slidesPerView: 3,
        spaceBetween: 0,
        noSwiping: true,
        onlyExternal: true,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 0,
        noSwiping: true,
        onlyExternal: true,
      }
    },
  });
}
if(document.querySelector('.banner_slideshow') != null){
  var swiper = new Swiper(".banner_slideshow", {});
}


// Product Accrodian
const accSingleTriggers = document.querySelectorAll('.course-accordion');

accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

function toggleAccordion() {
  const items = document.querySelectorAll('.accordion-list > li');
  const thisItem = this.parentNode;

  items.forEach(item => {
    if (thisItem == item) {
      thisItem.classList.toggle('is-open');
      return;
    }
    item.classList.remove('is-open');
  });
}
if(document.querySelector('.th-do-table') != null){
  window.onload = function(e){ 
    try {
      var XML = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function () {
        this.addEventListener("load", function () {
          if (this._url && this._url.search(/discount-box/) >= 0) {
            var th_table = document.querySelector('.th-do-table');
            var isEmpty = th_table.innerHTML === "";
            if(isEmpty){
            }else{
              qtyPriceUpdate();
            }
          }
        }), XML.apply(this, arguments);
      }
    } catch (A) {
      console.log(A), console.log("error catching ajax")
    }
  }
}

// Product Slider

if(document.querySelector('.product-main-slider') != null){
  var productSlider = new Swiper('.product-main-slider', {
    spaceBetween: 0,
    centeredSlides: false,
    loop:true,
    direction: 'horizontal',
    loopedSlides: 5,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    resizeObserver:true,
  });
  var productThumbs = new Swiper('.product-thumbs', {
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      slideToClickedSlide: true,
      direction: 'horizontal',
      slidesPerView: 5,
      loopedSlides: 5,
  });
  productSlider.controller.control = productThumbs;
  productThumbs.controller.control = productSlider;
}
if(document.querySelector('.productTestimonialSwiper') != null){
  var productTestimonialSwiper = new Swiper(".productTestimonialSwiper", {
   navigation: {
      nextEl: ".testimonial-swiper-button-next",
      prevEl: ".testimonial-swiper-button-prev",
    },
    pagination: {
      el: ".testimonial-swiper-pagination",
    }
  });
}

if(document.querySelector('.cartPageProSwiper') != null){
  var cartPageProSwiper = new Swiper(".cartPageProSwiper", {
    draggable: false,
    slidesPerView: "auto",
    
    spaceBetween: 8,
    noSwiping: true,
    onlyExternal: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
    750: {
      spaceBetween: 30,
      slidesPerView: 3,
      noSwiping: true,
      onlyExternal: true,
    },
    1200: {
      spaceBetween: 70,
      slidesPerView: 4,
      noSwiping: true,
      onlyExternal: true,
    }
   }
  });
}

if(document.querySelectorAll('.variant__button-input').length > 0){
  var inputElements = document.querySelectorAll('.variant__button-input');
  for(i=0;i<inputElements.length;i++){
    inputElements[i].addEventListener('change',variantSelectorsValue);
  }
}

if(document.querySelectorAll('.SingleOptionSelector--option').length > 0){
  var variantSelectors  = document.querySelectorAll('.SingleOptionSelector--option');
  variantSelectors.forEach((select) => {
    select.addEventListener('change', function() {
      var finalvalue = '';
      var selectVal = this.value;
      var sizeCheckbox = select.closest('.variant_selector_wrapp').querySelector(".variant__button-input[value='"+selectVal+"']");
      sizeCheckbox.checked = true;
      
      var event = new Event('change');
      sizeCheckbox.dispatchEvent(event);

    });
  });
}

function variantSelectorsValue(event) {
  var finalvalue = '';
  var parentNode = event.currentTarget.closest('.variant_selector_wrapp').querySelectorAll('.variant__button-input:checked');

  parentNode.forEach((element,index) => {
    var newvalue = element.value;
    if(element.classList.contains('variant__size')){
      var lbl = element.value;
      var sizeLbl = lbl.split(' - ');
      if(sizeLbl[1] != undefined){
        element.closest('.product-form__input').querySelector('.size_label').textContent = sizeLbl[1];
        element.closest('.variant_selector_wrapp').querySelector('.variant-wrapper--dropdown .size_label').textContent = sizeLbl[1];
      }else{
        element.closest('.product-form__input').querySelector('.size_label').textContent = sizeLbl;
        element.closest('.variant_selector_wrapp').querySelector('.variant-wrapper--dropdown .size_label').textContent = sizeLbl;
      }
      
    }
    if(finalvalue == ''){
      finalvalue = newvalue;
    }else{
      finalvalue += ' / '+newvalue;
    }
  });

  var selectElement = event.currentTarget.closest('.variant_selector').querySelector('.coll-variant-select');

  if(selectElement.querySelector("option[value='"+finalvalue+"']")){
    var dataID = Number(selectElement.querySelector("option[value='"+finalvalue+"']").getAttribute('data-id'));
  }


  if(selectElement.querySelector("option[value='"+finalvalue+"']")){
    var dataQty = Number(selectElement.querySelector("option[value='"+finalvalue+"']").getAttribute('data-qty'));
  }

  if(selectElement.querySelector("option[value='"+finalvalue+"']")){
    var dataImage = selectElement.querySelector("option[value='"+finalvalue+"']").getAttribute('data-image');
  }

  var currentImage = event.currentTarget.closest('.card').querySelector('.card__inner .media img');
  if(currentImage != null){
    currentImage.src = dataImage;
  }

  var cartBtn = event.currentTarget.closest('.quick-add').querySelector('.custom-add-to-cart');
  var cartrecomInput = event.currentTarget.closest('.quick-add').querySelector('.cart_page_proid');
  var cartrecombtn = event.currentTarget.closest('.quick-add').querySelector('.custom-opt-btn');
  var cartInput = event.currentTarget.closest('.quick-add').querySelector('input[name="id"]');

  if(cartInput != null){
    cartInput.value = dataID;
  }

  if(cartBtn != null){
    cartBtn.setAttribute('data-id', dataID);
    if(dataQty > 0){
      cartBtn.removeAttribute('disabled');
      cartBtn.getElementsByTagName('span')[0].classList.remove("hidden");
      cartBtn.querySelector('.sold-out-message').classList.add("hidden");
    }else{
      cartBtn.setAttribute('disabled', true);
      cartBtn.querySelector('.sold-out-message').classList.remove("hidden");
      cartBtn.getElementsByTagName('span')[0].classList.add("hidden");
    }
  }

  if(cartrecombtn != null){
    cartrecombtn.setAttribute('data-id', dataID);
    if(dataQty > 0){
      cartrecombtn.removeAttribute('disabled');
    }else{
      cartrecombtn.setAttribute('disabled', true);
    }
  }

  if(cartrecomInput != null){
    cartrecomInput.value = dataID;
  }

}

var docWidth = document.documentElement.clientWidth;

function handleChange(){
 

    var allSelectors = document.querySelectorAll('.bag-design-dropdown select');

    allSelectors.forEach(selector => {
      var value = selector.value;
      var option = selector.options[selector.selectedIndex];
      var dataInput = option.getAttribute("data-value");

      var getInput = selector.closest(".custom__dropdown").querySelector('.color-input-field[data-label="'+dataInput+'"]');
      
      var getAllInput = selector.closest(".custom__dropdown").querySelectorAll('.color-input-field');
      for(i=0;i<getAllInput.length;i++){
        getAllInput[i].classList.remove("active");
      }

      if(!getInput.classList.contains('hidden')){
        getInput.classList.add("active");
      }

      if(getPreviousSiblings(getInput, '.color-input-field').length > 0){
        var allInput = getPreviousSiblings(getInput, '.color-input-field');
        allInput.forEach((input,index) => {
          if(!input.classList.contains('hidden')){
            input.classList.add("active");
          }
        });
      }

      if(value == '0'){
        for(i=0;i<getAllInput.length;i++){
          getAllInput[i].classList.remove("active");
        }
      }
      customBagColor();

      if(selector.closest(".front-bag-design") != null){
        var frontAllInput = selector.closest(".front-bag-design").querySelectorAll('.color-input-field.active');
        frontAllInput.forEach((frontInput,index) => {
          frontInput.oninput = function()
          {
            customBagColor();
          };
        });
      }
      if(selector.closest(".rear-bag-design") != null){
        var rearAllInput = selector.closest(".rear-bag-design").querySelectorAll('.color-input-field.active');
        rearAllInput.forEach((rearInput,index) => {
          rearInput.oninput = function()
          {
            customBagColor();
          };
        });
      }
    });

  
};


function customBagColor() {
  
    var bags = document.querySelectorAll('.front-bag-design .color-input-field.active');
    var bagsvalues = '';
    for(var i = 0; i < bags.length; i++){
        var index = Number(i) + 1;
        if(bags[i].value != ''){
          var bagsvalues = bagsvalues + bags[i].value + ',';
        }
    }
    var newArrVal = bagsvalues.substr(0, bagsvalues.length - 1);
    document.getElementById('custom-property-front').value = newArrVal;
    
    var rearbags = document.querySelectorAll('.rear-bag-design .color-input-field.active');
    var rearbagsvalues = '';
    for(var j = 0; j < rearbags.length; j++){
        var rearindex = Number(j) + 1;
        if(rearbags[j].value != ''){
          var rearbagsvalues = rearbagsvalues + rearbags[j].value + ',';
        }
    }
    var rearnewArrVal = rearbagsvalues.substr(0, rearbagsvalues.length - 1);
    document.getElementById('custom-property-rear').value = rearnewArrVal;
  
    if(document.getElementById('custom-property-front') != null || document.getElementById('custom-property-rear') !=  null ){
      var frontProp = document.getElementById('custom-property-front');
      var rearProp = document.getElementById('custom-property-rear');
      var submitButton = document.getElementsByClassName('product-form__submit')[0];

      var inputActive = document.querySelectorAll('.color-input-field.active');
      var inputValCount = 0;
      if(inputActive.length > 0){
        for(var k = 0; k < inputActive.length; k++){
          if(inputActive[k].value != ''){
            inputValCount = inputValCount + 1;
          }
        }
      }
    }
  
}

if(document.querySelectorAll('.front-bag-design .color-input-field.active').length > 0){
  var frontInputElements = document.querySelectorAll('.front-bag-design .color-input-field.active');
  frontInputElements.forEach((frontInput,index) => {
    frontInput.oninput = function()
    {
      customBagColor();
    };
  });

}
if(document.querySelectorAll('.rear-bag-design .color-input-field.active').length > 0){
  var rearInputElements = document.querySelectorAll('.rear-bag-design .color-input-field.active');
  rearInputElements.forEach((rearInput,index) => {
    rearInput.oninput = function()
    {
      customBagColor();
    };
  });
}
if(document.querySelectorAll('.bag-design-dropdown select').length > 0){
  window.addEventListener("load", (event) => {
    customBagColor();
  });
}


function getPreviousSiblings(elem, filter) {
  var sibs = [];
  while (elem = elem.previousSibling) {
    if (matches(elem, filter)) {
      sibs.push(elem);
    }
  }
  return sibs;
}
function matches(elem, filter) {
  if (elem && elem.nodeType === 1) {
    if (filter) {
      return elem.matches(filter);
    }
    return true;
  }
  return false;
}
function equalHeight(resize) {
  var elements = document.querySelectorAll(".swiper-slide .card__heading"),
      allHeights = [],
      i = 0;
  if(resize === true){
    for(i = 0; i < elements.length; i++){
      elements[i].style.minHeight = 'auto';
    }
  }
  for(i = 0; i < elements.length; i++){
    var elementHeight = elements[i].clientHeight;
    allHeights.push(elementHeight);
  }
  for(i = 0; i < elements.length; i++){
    elements[i].style.minHeight = Math.max.apply( Math, allHeights) + 'px';
    if(resize === false){
      elements[i].className = elements[i].className + " show";
    }
  }
}
(function () {
  equalHeight(false);
})();

window.onresize = function(){
  equalHeight(true);
}
function equalVariantHeight(resize) {
  var elements = document.querySelectorAll(".cart-recom-pro .variant_selector"),
      allHeights = [],
      i = 0;
  if(resize === true){
    for(i = 0; i < elements.length; i++){
      elements[i].style.minHeight = 'auto';
    }
  }
  for(i = 0; i < elements.length; i++){
    var elementHeight = elements[i].clientHeight;
    allHeights.push(elementHeight);
  }
  for(i = 0; i < elements.length; i++){
    elements[i].style.minHeight = Math.max.apply( Math, allHeights) + 'px';
    if(resize === false){
      elements[i].className = elements[i].className + " show";
    }
  }
}
(function () {
  equalVariantHeight(false);
})();

window.onresize = function(){
  equalVariantHeight(true);
}

